/**
 * Ask the service worker to purge the runtime API cache (`kidshome-api`) on logout / persona switch, so
 * the next account on a shared device is never served the previous user's cached reads (defence-in-depth
 * alongside the SW's per-account cache-key partitioning).
 *
 * Prefer the page's active CONTROLLER, but fall back to `registration.active` when the page isn't yet
 * controlled — the first session before `clientsClaim()` takes effect, or the brief window during an SW
 * update / `controllerchange`. Without the fallback the purge is silently dropped in exactly the moment
 * a handoff is most likely to race an activation.
 */
export function clearApiCache(): void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  const message = { type: 'CLEAR_API_CACHE' as const };
  const controller = navigator.serviceWorker.controller;
  if (controller) {
    controller.postMessage(message);
    return;
  }
  // Not controlled yet — resolve the registration and post to its active worker if one exists.
  void navigator.serviceWorker.getRegistration().then((reg) => {
    reg?.active?.postMessage(message);
  });
}
